import { render, staticRenderFns } from "./polygonCustom.vue?vue&type=template&id=c67ad6bc&scoped=true"
import script from "./polygonCustom.vue?vue&type=script&lang=js"
export * from "./polygonCustom.vue?vue&type=script&lang=js"
import style0 from "./polygonCustom.vue?vue&type=style&index=0&id=c67ad6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ad6bc",
  null
  
)

export default component.exports